import { ActionsPage } from '../'
import { branch } from '../constants'

module.exports = ->

  (await ActionsPage.list())
    .filter((configNode) -> configNode.get('serviceCall') is 'importExcel')
    .map((configNode) ->
      configNode.set('serviceCall', 'import')
      configNode.save({ branch })
    )
